import { contactData } from '@/mocks/home';

export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-[900px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">联系我们</h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            {contactData.subtitle}
          </p>
        </div>
        <div className="bg-background-100 rounded-xl border border-background-200/60 p-6 md:p-10">
          <p className="text-sm text-foreground-600 leading-relaxed mb-8">
            {contactData.description}
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-5">
            <div className="flex items-start gap-3 p-4 rounded-lg bg-background-50 border border-background-200/40">
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 flex-shrink-0">
                <i className="ri-mail-line text-accent-600 text-lg"></i>
              </div>
              <div>
                <div className="text-xs text-foreground-400 mb-1">电子邮箱</div>
                <div className="text-sm font-medium text-foreground-800">{contactData.email}</div>
              </div>
            </div>
            <div className="flex items-start gap-3 p-4 rounded-lg bg-background-50 border border-background-200/40">
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 flex-shrink-0">
                <i className="ri-wechat-line text-accent-600 text-lg"></i>
              </div>
              <div>
                <div className="text-xs text-foreground-400 mb-1">微信公众号</div>
                <div className="text-sm font-medium text-foreground-800">{contactData.wechat}</div>
              </div>
            </div>
            <div className="flex items-start gap-3 p-4 rounded-lg bg-background-50 border border-background-200/40">
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 flex-shrink-0">
                <i className="ri-qq-line text-accent-600 text-lg"></i>
              </div>
              <div>
                <div className="text-xs text-foreground-400 mb-1">QQ交流群</div>
                <div className="text-sm font-medium text-foreground-800">{contactData.qq}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}